import React, { Component } from 'react';
import { Table, } from 'antd';
import PropTypes from 'prop-types';
import styles from './PackTable.module.scss';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import { XPagination, } from '@/components/xqxc_ui';


export default class PackTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    _columns = () => [
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            width: '30%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        // {
        //     title: '编码',
        //     dataIndex: 'code',
        //     key: 'code',
        //     width: '10%',
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '终端',
            dataIndex: 'systemTypeValue',
            key: 'systemTypeValue',
            width: '30%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '30%',
            render: (id, item) => this._tableAction(id, item)
        },
    ];

    // 解析表格数据，使符合columns格式要求
    _takeDataSource = (data) => {
        if (data) {
            return data.map(item => {
                return item;
            });
        }
    }

    //表格操作
    _tableAction = (key, item) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, 'edite', item)}>编辑</div>
            </div>
        );
    };

    //渲染组件
    render() {
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        const { paginationChange } = this.props;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

PackTable.propTypes = {
    renderData: PropTypes.object, // 表格数据源
    tableAction: PropTypes.func, // 表格
    paginationChange: PropTypes.func.isRequired, // 分页操作
};